const accordionTriggers = document.querySelectorAll<HTMLButtonElement>(
  '[data-dmp-accordion-trigger]'
);
if (accordionTriggers.length === 0) {
  // DMPページ以外では何もしない
} else {
  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const section = trigger.closest('section');
      if (!section) return;

      const content = section.querySelector<HTMLElement>(
        '[data-dmp-accordion-content]'
      );
      if (!content) return;

      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      trigger.setAttribute('aria-expanded', (!isExpanded).toString());
      content.hidden = isExpanded;

      const icon = trigger.querySelector('i');
      if (icon) {
        icon.classList.toggle('fa-angle-up', !isExpanded);
        icon.classList.toggle('fa-angle-down', isExpanded);
      }
    });
  });

  const sidebar = document.querySelector<HTMLDivElement>('[data-dmp-sidebar]');
  const toggleButton = document.querySelector<HTMLButtonElement>(
    '[data-sidebar-toggle]'
  );

  toggleButton?.addEventListener('click', () => {
    const isOpen = sidebar?.getAttribute('data-dmp-open') === 'true';
    sidebar?.setAttribute('data-dmp-open', String(!isOpen));
  });

  // 左カラムのアンカーリンクをクリック時、右カラムのみスクロールさせる
  const contentArea =
    document.querySelector<HTMLDivElement>('[data-dmp-content]');
  const sidebarLinks =
    sidebar?.querySelectorAll<HTMLAnchorElement>('a[href^="#dmp-"]');
  sidebarLinks?.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = link.getAttribute('href')?.slice(1);
      history.pushState(null, '', `#${targetId}`);
      if (!targetId) return;
      const targetEl = document.getElementById(targetId);
      if (!targetEl) return;

      const currentIsMobile = window.matchMedia('(max-width: 767px)').matches;

      if (currentIsMobile) {
        sidebar?.setAttribute('data-dmp-open', 'false');
      }
      if (!contentArea) return;
      const targetRect = targetEl.getBoundingClientRect();
      const containerRect = contentArea.getBoundingClientRect();
      contentArea.scrollTo({
        top: contentArea.scrollTop + targetRect.top - containerRect.top,
        behavior: 'smooth',
      });
    });
  });
}
